import {Injectable, NgZone} from "@angular/core";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../shared/redux-store/store";
import {AbstractVisbosControl} from "../../core/visbos-core/ui/forms/abstract-visbos-control";
import {WithdrawalConsumerInterface} from "../model/withdrawal-consumer-interface.type";
import {Stock} from "../../shared/view-model/stock";
import {WithdrawalReasonInterface} from "../model/withdrawal-reason-interface.type";
import {WithdrawalService} from "../services/withdrawal.service";
import {SessionActions} from "../../shared/actions/session.actions";
import {MessageType} from "../../shared/redux-store/session/session.types";
import {UserService} from "../../crm/user/user.service";
import {Observable} from "rxjs/Observable";
import {Withdrawal} from "../model/withdrawal";
import {VisbosErrorHandlerService} from "../../core/visbos-core/error-handling/visbos-error-handler.service";
import {catchError, finalize, tap} from "rxjs/operators";
import {forkJoin} from "rxjs/observable/forkJoin";
import {of} from "rxjs/observable/of";
import {empty} from 'rxjs/observable/empty';
import * as _ from 'lodash';

@Injectable()
export class WithdrawalActions {

  static CREATE_WITHDRAWAL = 'CREATE_WITHDRAWAL';
  static SET_ACTIVE_WITHDRAWAL = 'SET_ACTIVE_WITHDRAWAL';

  static SET_NOTE = 'SET_NOTE';

  static SELECT_CONSUMER = 'SELECT_CONSUMER';
  static SELECT_REASON = 'SELECT_REASON';

  static SELECT_USER_INIT = 'SELECT_USER_INIT';
  static SELECT_USER_SUCCESS = 'SELECT_USER_SUCCESS';
  static SELECT_USER_ERROR = 'SELECT_USER_ERROR';

  static WITHDRAW_STOCK = 'WITHDRAW_STOCK';
  static CHANGE_STOCK_AMOUNT = 'CHANGE_STOCK_AMOUNT';
  static REMOVE_STOCK_FROM_WITHDRAWAL = 'REMOVE_STOCK_FROM_WITHDRAWAL';

  static COMMIT_WITHDRAWAL_SUCCESS = 'COMMIT_WITHDRAWAL_SUCCESS';
  static COMMIT_WITHDRAWAL_ERROR = 'COMMIT_WITHDRAWAL_ERROR';

  static COMMIT_WITHDRAWALS_INIT = 'COMMIT_WITHDRAWALS_INIT';
  static COMMIT_WITHDRAWALS_SUCCESS = 'COMMIT_WITHDRAWALS_SUCCESS';
  static COMMIT_WITHDRAWALS_ERROR = 'COMMIT_WITHDRAWALS_ERROR';

  static CANCEL_WITHDRAWAL = 'CANCEL_WITHDRAWAL';

  constructor(private ngRedux: NgRedux<IAppState>, private wdService: WithdrawalService, private sessionActions: SessionActions, private userService: UserService, private err: VisbosErrorHandlerService) {
  }

  createNewWithdrawal(): string {
    let cuid = AbstractVisbosControl.cuid();

    this.ngRedux.dispatch({
      type: WithdrawalActions.CREATE_WITHDRAWAL,
      payload: {
        cuid: cuid,
        withdrawal_timestamp: new Date(),
        administration_unit_id: this.ngRedux.getState().session.activeAdminUnit,
        authenticated_user_id: this.ngRedux.getState().session.user.cuid
      }
    });

    this.selectWithdrawal(cuid);

    return cuid;
  }

  selectWithdrawal(withdrawalCuid: string) {
    this.ngRedux.dispatch({
      type: WithdrawalActions.SET_ACTIVE_WITHDRAWAL,
      payload: withdrawalCuid
    });
  }

  selectConsumer(withdrawalCuid: string, consumer_type: string, consumer: WithdrawalConsumerInterface) {
    this.ngRedux.dispatch({
      type: WithdrawalActions.SELECT_CONSUMER,
      payload: {
        withdrawal_id: withdrawalCuid,
        consumer: {
          consumer_id: consumer.cuid,
          consumer_type: consumer_type,
          consumer: consumer
        }
      }
    });
  }

  selectUserByPersonalNumber(personalNumber: any, signature: string) {

    this.ngRedux.dispatch({
      type: WithdrawalActions.SELECT_USER_INIT,
      payload: {
        personal_number: personalNumber,
        signature: signature
      }
    });

    this.ngRedux.dispatch({
      type: WithdrawalActions.SELECT_USER_SUCCESS,
      payload: {
        user: this.ngRedux.getState().session.user
      }
    });

    //TODO: Change to real authentication mechanism!!

    /*
     this.userService.getUserByPersonalNumber(personalNumber).toPromise()
     .then(res => {
     let user = res.data.user;

     this.ngRedux.dispatch({
     type: WithdrawalActions.SELECT_USER_SUCCESS,
     payload: {
     user: user
     }
     });
     })
     .catch(err => {
     this.ngRedux.dispatch({
     type: WithdrawalActions.SELECT_USER_ERROR
     });
     });
     */
  }

  selectWithdrawalReason(withdrawalCuid: string, reason_type: string, reason?: WithdrawalReasonInterface) {
    this.ngRedux.dispatch({
      type: WithdrawalActions.SELECT_REASON,
      payload: {
        withdrawal_id: withdrawalCuid,
        reason: {
          withdrawal_reason_id: reason ? reason.cuid : null,
          withdrawal_reason_type: reason_type,
          withdrawal_reason: reason ? reason : null
        }
      }
    });
  }

  setNote(withdrawalCuid: string, note: string) {
    this.ngRedux.dispatch({
      type: WithdrawalActions.SET_NOTE,
      payload: {
        withdrawal_id: withdrawalCuid,
        note: note
      }
    });
  }

  addStockToWithdrawal(withdrawalCuid: string, stock: Stock, amount?: number) {
    let compAmount = stock.extraction_amount ? stock.extraction_amount : 1;
    this.ngRedux.dispatch({
      type: WithdrawalActions.WITHDRAW_STOCK,
      payload: {
        cuid: AbstractVisbosControl.cuid(),
        withdrawal_id: withdrawalCuid,
        stock: _.cloneDeep<Stock>(stock),
        amount: amount ? amount : (compAmount)
      }
    });
  }

  removeStockFromWithdrawal(withdrawalCuid: string, stock: Stock) {
    this.ngRedux.dispatch({
      type: WithdrawalActions.REMOVE_STOCK_FROM_WITHDRAWAL,
      payload: {
        withdrawal_id: withdrawalCuid,
        stock: stock,
      }
    });
  }

  setStockAmountForWithdrawal(withdrawalCuid: string, stock: Stock, amount: number) {
    this.ngRedux.dispatch({
      type: WithdrawalActions.CHANGE_STOCK_AMOUNT,
      payload: {
        withdrawal_id: withdrawalCuid,
        stock: stock,
        amount: amount
      }
    });
  }

  commitWithdrawals(): Observable<any> {

    if (this.ngRedux.getState().withdrawals.is_committing) {
      console.warn("Already committing withdrawals...");
      return empty();
    }

    this.ngRedux.dispatch({
      type: WithdrawalActions.COMMIT_WITHDRAWALS_INIT
    });



    let wds = this.ngRedux.getState().withdrawals.withdrawalList;

    let noWds = 0;
    let noErrors = 0;
    let noSuccess = 0;

    let queries: Observable<Withdrawal>[] = [];

    for (let wd of wds) {

      if (wd.consumer && wd.withdrawn_stocks && wd.withdrawn_stocks.length > 0) {

        let wdInput = {
          cuid: wd.cuid,
          administration_unit_id: wd.administration_unit_id,
          withdrawal_timestamp: wd.withdrawal_timestamp,
          withdrawal_reason_id: wd.withdrawal_reason_id,
          withdrawal_reason_type: wd.withdrawal_reason_type,
          consumer_id: wd.consumer_id,
          consumer_type: wd.consumer_type,
          withdrawn_stocks: wd.withdrawn_stocks
        };

        let medAuthData = {
          authenticated_user_token: this.ngRedux.getState().session.token,
          authenticated_user_cuid: wd.authenticated_user ? wd.authenticated_user.cuid : this.ngRedux.getState().session.user.cuid,
          personal_number: wd.personal_number,
          signature: wd.signature
        };

        noWds++;
        queries.push(
          this.wdService.createWithdrawal(wdInput, medAuthData).pipe(
            tap(wdRes => {
              noSuccess++;
              this.ngRedux.dispatch({
                type: WithdrawalActions.COMMIT_WITHDRAWAL_SUCCESS,
                payload: {
                  withdrawal_id: wdRes.cuid
                }
              });
            }),
            catchError(err => {

              if (err.networkError) {
                console.warn("Network error during committing withdrawals", [err]);
              } else {
                noErrors++;
                this.err.handleError(err, "Error creating withdrawal: #" + wdInput.cuid, () => {
                  this.ngRedux.dispatch({
                    type: WithdrawalActions.COMMIT_WITHDRAWAL_ERROR,
                    payload: {
                      withdrawal_id: wd.cuid,
                      error: err
                    }
                  });
                });
              }

              return of(<Withdrawal>{});
            })
          )
        );

      } else {
        this.cancelWithdrawal(wd.cuid);
      }

    }

    // Watch all queries
    let res = forkJoin(queries).pipe(
      tap(
        res => {
          if (noErrors == 0 && noSuccess > 0) {
            this.sessionActions.pushMessage("Die Artikelentnahme wurde erfolgreich abgeschlossen! " + noSuccess + " Entnahmen wurden übertragen.", MessageType.SUCCESS, "Artikelentnahme");
            this.finishWithdrawalsTransaction();
          } else if (noErrors > 0) {
            this.sessionActions.pushMessage("Während der Artikelentnahme ist ein Fehler aufgetreten (Erfolgreich übertragen: " + noSuccess + ", Fehler: " + noErrors + "), bitte wenden Sie sich an den Support!", MessageType.ERROR, "Artikelentnahme");
            this.finishWithdrawalsTransactionWithErrors();
          } else if (noSuccess == 0) {
            this.finishWithdrawalsTransactionWithErrors();
          } else {
            this.finishWithdrawalsTransaction();
          }
        }
      ),
      finalize(() => {
        if (noErrors > 0 || noSuccess == 0) {
          this.finishWithdrawalsTransactionWithErrors();
        } else {
          this.finishWithdrawalsTransaction();
        }
      })
    );

    return res;

  }

  finishWithdrawalsTransaction() {
    this.ngRedux.dispatch({
      type: WithdrawalActions.COMMIT_WITHDRAWALS_SUCCESS
    });
  }

  finishWithdrawalsTransactionWithErrors() {
    this.ngRedux.dispatch({
      type: WithdrawalActions.COMMIT_WITHDRAWALS_ERROR
    });
  }

  cancelWithdrawal(withdrawalId: string) {
    this.ngRedux.dispatch({
      type: WithdrawalActions.CANCEL_WITHDRAWAL,
      payload: {
        withdrawal_id: withdrawalId
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/redux/scans.actions.ts